module.exports = __webpack_public_path__ + "static/img/bg_de.44c1e50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bts-2026-sale/bg_de.png
// module id = trIt
// module chunks = 2